<template>
  <div class="modal-out">
    <div class="modal">
      <div class="modal-header">
        <div style="padding: 6px;">添加</div>
        <button type="button" class="btn-close" @click="closeSelf">X</button>
      </div>
      <div class="modal-body">

        <el-row class="row">
          <el-col :span="12" class="item">
            <div class="label">登录账号</div>
            <el-input v-model="add_loginName" placeholder="请输入登录账号"></el-input>
          </el-col>
          <el-col :span="12" class="item">
            <div class="label">登录密码</div>
            <el-input v-model="add_password" placeholder="请输入登录密码" show-password></el-input>
          </el-col>
        </el-row>

        <el-row class="row">
          <el-col :span="12" class="item">
            <div class="label">姓名</div>
            <el-input v-model="add_realName" placeholder="请输入姓名"></el-input>
          </el-col><el-col :span="12" class="item">
          <div class="label">选择角色</div>
          <el-select v-model="add_roleCode" placeholder="选择角色" style="width:100%">
            <el-option
                v-for="item in roleList"
                :key="item.roleCode"
                :label="item.name"
                :value="item.roleCode">
            </el-option>
          </el-select>
        </el-col>
        </el-row>

        <el-row class="row">
          <el-col :span="12" class="item">
            <div class="label">手机</div>
            <el-input v-model="add_phone" placeholder="请输入手机"></el-input>
          </el-col>

        </el-row>


      </div>
      <div class="modal-footer">
        <el-button :loading="loading" type="primary" @click.native="confirm">确认</el-button>
      </div>
    </div>

  </div>
</template>


<script>

import {getGovernmentCode, getStaffCode} from "@/utils/auth";
import {timeStr} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";


export default {
  name: 'Add',
  props: [],
  data() {
    return {

      loading: false,


      add_loginName:'',
      add_password:'',
      add_realName:'',
      add_roleCode:'',
      add_phone:'',
      add_governmentCode:getGovernmentCode(),

      roleList:null,


    }
  },
  components:{

  },
  methods: {
    init(){
      this.add_loginName = '';
      this.add_password = '';
      this.add_realName = '';
      this.add_roleCode = '';
      this.add_phone = '';

      this.getRoleList();
    },

    closeSelf() {
      this.loading= false
      this.$emit("closeAdd");
    },

    confirm(){

      if(this.loading){
        return;
      }else{
        this.loading = true;
      }


      if(this.add_loginName == ''){
        this.$message('请输入用户名');
        this.loading = false;
        return;
      }
      if(this.add_password == ''){
        this.$message('请输入密码');
        this.loading = false;
        return;
      }
      if(this.add_realName == ''){
        this.$message('请添加用户名');
        this.loading = false;
        return;
      }
      if(this.add_phone == ''){
        this.$message('请添加手机号');
        this.loading = false;
        return;
      }


      this.$axios({
        method: 'post',
        url: this.$shopUrl+'Staff/AddGov',
        data: {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode: getStaffCode(),
          loginName: this.add_loginName,
          password:this.add_password,
          realName:this.add_realName,
          roleCode:this.add_roleCode,
          phone:this.add_phone,
          governmentCode:this.add_governmentCode,

        }

      }).then( (response)=> {
        //console.log(response.data);
        this.loading = false;
        if(response.data.error == 0){
          this.$emit("closeAdd");
          this.$emit("getList");
        }else if(response.data.error == 1){
          this.$message(response.data.message);
        }else{
          console.log(response.data.message);
        }

      }).catch(function (error) {
        console.log(error);
      });

    },


    getRoleList(){
      this.$axios({
        method: 'post',
        url: this.$shopUrl+'Role/ListForAuto',
        data: {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode: getStaffCode(),
        }
      }).then((response)=> {
        if(response.data.error == 0){
          this.roleList = response.data.data;
          this.add_roleCode = this.roleList[0].roleCode;

        }else if(response.data.error == 1){
          this.$message(response.data.message);
        }else{
          console.log(response.data.message);
        }
      }).catch(function (error) {
        console.log(error);
      });
    },


  }
}
</script>


<style>

</style>
